import { ReactNode } from 'react';

type NsAnchorProps = {
  href?: React.AnchorHTMLAttributes<HTMLAnchorElement>['href'];
  rel?: React.AnchorHTMLAttributes<HTMLAnchorElement>['rel'];
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  testId?: string;
  attributes?: object;
  id?: React.AnchorHTMLAttributes<HTMLAnchorElement>['id'];
  children?: ReactNode;
};

export const NsAnchor = (props: NsAnchorProps) => {
  const isElementAnchor = props.href?.startsWith('#');
  const {
    href = '',
    rel = 'noopener noreferrer',
    target = isElementAnchor ? '_self' : '_blank',
    testId = 'anchorTestId',
    id,
    attributes = {},
    children
  } = props;

  const onClick = (event) => {
    if (isElementAnchor) {
      event.preventDefault();
      const target = document.querySelector(href);
      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start'
      });
    }
  };

  return (
    <a
      {...attributes}
      onClick={onClick}
      rel={rel}
      href={href}
      target={target}
      data-testid={testId}
      id={id}
    >
      {children}
    </a>
  );
};
